exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner {\n    border: 4px solid white;\n    border-top: 4px solid hsla(213, 86%, 73%, 1);\n    border-radius: 50%;\n    width: 25px;\n    height: 25px;\n    animation: spin 1s linear infinite;\n\n    /*position: absolute;*/\n    /*top: 35%;*/\n    /*right: 35%;*/\n    /*transform: translate(50%, 50%);*/\n    z-index: 1;\n\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}", ""]);

// exports
